<div class="mbm-chips">
  @for (chip of chips(); track chip.id) {
    <button type="button" class="mbm-chip" [class.mbm-chip-on]="isOn(chip)" [class.mbm-chip-dropdown]="chip.dropdown"
      [attr.data-chip-id]="chip.id" [attr.aria-pressed]="isOn(chip)" (click)="select(chip)">
      @if (chip.color) {
        <span class="mbm-chip-dot" [style.background]="chip.color" aria-hidden="true"></span>
      }
      <span>{{ chip.label ?? (chip.labelKey! | translate) }}</span>
      @if (chip.count !== undefined) {
        <span class="mbm-chip-count">{{ chip.count }}</span>
      }
      @if (chip.dropdown) {
        <img class="mbm-chip-chevron" src="assets/icons/chevron-down-sm.svg" alt="" aria-hidden="true">
      }
    </button>
  }
  <ng-content></ng-content>
</div>
